type Props = {
	/**
	 * @todo React.ReactNode に変更して内容の自由度を高める
	 */
	guide?: string;
};

import { memo, useCallback, useState } from "react";

import { sanitize } from "@/lib/dompurify";

import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card/hover-card";
import HelpIcon from "@/components/ui/icon/help";

import type { MouseEventHandler } from "react";

/**
 *
 * @param guide - Displayed on hover. Also, since it is an argument of dangerouslySetInnerHTML, it must be a string or an html tag.
 */
export const EditGuideTooltip = memo(({ guide }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOpenChange = useCallback((open: boolean) => {
		setIsOpen(open);
	}, []);

	const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
		(e) => {
			e.preventDefault();
			setIsOpen(!isOpen);
		},
		[isOpen],
	);

	if (!guide) return null;

	return (
		<HoverCard open={isOpen} onOpenChange={handleOpenChange}>
			<HoverCardTrigger className="inline-block rounded-full hover:bg-zinc-100" onClick={handleClick}>
				<HelpIcon className="h-[18px] w-[18px]" />
			</HoverCardTrigger>
			<HoverCardContent side={"top"} align={"start"} sideOffset={8} className="w-96">
				<p dangerouslySetInnerHTML={{ __html: sanitize(guide) }} className="text-sm" />
			</HoverCardContent>
		</HoverCard>
	);
});

EditGuideTooltip.displayName = "EditGuideTooltip";
